export const fromLocalStorageValue = (value) => {
	try {
		// work with types: number, boolean, object, null
		const parsedValue = JSON.parse(value)
		if (typeof parsedValue === 'number' && /^[0-9]+E-[0-9]+$/i.test(value)) {
			return value
		}

		return parsedValue
	} catch (e) {
		// work with string
		return value
	}
}
